module.exports = __webpack_public_path__ + "bab4eaae7e78152e4d342416a47abccc.png";